import { find, isEmpty } from "../../utils/lodash";
import { hasSetting, getSettingBoolean } from "./settingUtilities";
import { ChoiceModel } from "../ChoiceModel";
import { NumericRankingModel } from "../NumericRankingModel";
import { SoftPromptChoiceType } from "../enums/SoftPromptChoiceType";
import { isGrid } from "../enums/QuestionType";
import { NavigationResultChoiceModel } from "../NavigationResultChoiceModel";
import { QuestionModel } from "../QuestionModel";

export function hasOpenEnd(choice: ChoiceModel) {
    return hasSetting(choice, "OpenEndType") && !getSettingBoolean(choice, "OpenEndType", "None");
}

export function getChoiceRanking(choice: ChoiceModel, rankings: NumericRankingModel[]) {
    const ranking = find(rankings, (r) => r.choiceValue === choice.value);
    if (ranking) {
        return ranking.rankingValue;
    }
    return "";
}

export function isHeader(choice: ChoiceModel) {
    return isEmpty(choice.value);
}

export function isVisible(choice: ChoiceModel) {
    return !hasSetting(choice, "Visible") || getSettingBoolean(choice, "Visible");
}

export function isDefault(choice: ChoiceModel) {
    return getSettingBoolean(choice, "Default");
}

export const shouldSetSoftPrompt = (choice: ChoiceModel, softPromptType: SoftPromptChoiceType) => {
    switch (softPromptType) {
        case SoftPromptChoiceType.Invisible:
            return !isVisible(choice);
        case SoftPromptChoiceType.VisibleDefault:
            return isDefault(choice) && isVisible(choice);
        case SoftPromptChoiceType.Visible:
        default:
            return false;
    }
};

export function compareChoices(
    choice: ChoiceModel,
    navigationResultChoice: NavigationResultChoiceModel,
    question: QuestionModel,
): boolean {
    if (choice.position !== undefined) {
        return choice.position === navigationResultChoice.position;
    }

    const { type, parent } = question;
    const isGridOrInGrid = isGrid(type) || (parent && isGrid(parent.type));

    // Older versions of questionnaires don't have the field position.
    // Position starts on 1 for choice list, so we decrement to have the index.
    // For grids the position is already the index.
    const indexAdjust = isGridOrInGrid ? 0 : 1;
    const navigationResultChoiceIndex = navigationResultChoice.position - indexAdjust;

    return choice.index === navigationResultChoiceIndex;
}
